import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'removewhitespace',
    standalone: true
})
export class RemoveWhiteSpacePipe implements PipeTransform {
    transform(value: string): string {
        if (!value) {
            return value;
        }

        return value.replace(/ /g, '');
    }
}
